import React from 'react';
import smoothscroll from 'smoothscroll-polyfill';
import './InputLetter.css';

smoothscroll.polyfill();
const InputLetter = ({ inputType, inputHandler, onCloseHandler, state }) => {
    const input = document.getElementById('text');
    let letra = '';
    let letrasNoPermitidas = 'aeiouAEIOU';
    let titulo = 'Tu letra';
    if (inputType === 'vocal') {
        letrasNoPermitidas = 'bBcCdDfFgGhHjJkKlLmMnNñÑpPqQrRsStTvVwWxXyYzZ';
        titulo = 'Tu vocal';
    }

    function setLetra(e) {
        console.log(e);
        if (e.target.value.length > 1) {
            console.log('Mayor que 1');
            const primeraLetra = e.target.value.substr(0, 1);
            input.value = primeraLetra;
        }
        if (letrasNoPermitidas.includes(e.target.value)) {
            input.value = '';
        }
        letra = e.target.value.toUpperCase();
        if (e.target.value !== '') {
            input.blur();
        }
    }

    function onButtonClick(pasarLetra) {
        input.value = '';
        inputHandler(pasarLetra);
    }

    function onFocus() {
        const scrollTop = (window.screen.height / 100) * 11;
        setTimeout(() => {
            window.scrollTo({
                top: scrollTop,
                behavior: 'smooth',
            });
        }, 500);
    }

    return (
        <>
        <div className={`input__container ${state}`} id="input__container">
            <div className="input">
                <label htmlFor="text" className="input__tittle">{titulo}</label>
                <input
                  id="text"
                  type="text"
                  name="text"
                  className="input__letter"
                  autoComplete="off"
                  maxLength="1"
                  onTouchStart={onFocus}
                  onChange={(e) => setLetra(e)}
                />
                { inputType === 'vocal'
                ? <div className="vocal-coins">-50<img src={`${process.env.PUBLIC_URL}/img/coins.png`} alt="coins" className="vocal-coins__img" /></div>
                : null }
                <div>
                    <button type="button" className="input__button" onClick={() => onButtonClick(letra)}>OK</button>
                    { inputType === 'vocal'
                    ? <button type="button" className="input__button input__button--cancel" onClick={() => onCloseHandler()}>X</button>
                    : null }
                </div>
            </div>
        </div>
        </>
    );
};

export default InputLetter;
